import { t } from "../i18n/translations";


export function JoinWelcomeScreen({
  landingLang, setLandingLang, setRegisterForm,
  joinFamilyName, setJoinScreen,
}) {
  return (
    <div className="app-shell">
      <header className="header">
        <div className="header-titulo no-click">✦</div>
      </header>
      <div className="pantalla">
        <div className="contenido">
          <div className="join-screen">
            <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
              <button className={"lang-btn" + (landingLang === "en" ? " active" : "")}
                onClick={() => { setLandingLang("en"); setRegisterForm((f) => ({ ...f, language: "en" })); }}>🇬🇧 English</button>
              <button className={"lang-btn" + (landingLang === "es" ? " active" : "")}
                onClick={() => { setLandingLang("es"); setRegisterForm((f) => ({ ...f, language: "es" })); }}>🇲🇽 Español</button>
              <button className={"lang-btn" + (landingLang === "fi" ? " active" : "")}
                onClick={() => { setLandingLang("fi"); setRegisterForm((f) => ({ ...f, language: "fi" })); }}>🇫🇮 Suomi</button>
            </div>
            <p style={{ fontSize: 14, color: "#999", marginBottom: 8 }}>{t(landingLang, "welcomeToFamily")}</p>
            <div className="family-name-big">
              {joinFamilyName
                ? joinFamilyName
                : <span style={{ color: "#ccc", fontStyle: "italic", fontSize: "0.7em" }}>
                    {landingLang === "es" ? "Cargando…" : landingLang === "fi" ? "Ladataan…" : "Loading…"}
                  </span>
              }
            </div>
            <p>
              {landingLang === "es"
                ? "Crea una cuenta o inicia sesión para ver las Wishlus de todos 🎁"
                : landingLang === "fi"
                ? "Luo tili tai kirjaudu sisään nähdäksesi kaikkien Wishlut 🎁"
                : "Create an account or sign in to see everyone's Wishlus 🎁"}
            </p>
            <div className="join-btns">
              <button className="btn btn-dorado" onClick={() => setJoinScreen("register")}>
                {t(landingLang, "joinNow")}
              </button>
              <button className="btn btn-gris" onClick={() => setJoinScreen("login")}>
                {t(landingLang, "alreadyMember")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function JoinAuthScreen({
  joinScreen, setJoinScreen, landingLang,
  loginForm, setLoginForm, registerForm, setRegisterForm,
  authError, joinFamilyName,
  handleLogin, handleRegister, handleForgotPassword,
  termsAccepted, setTermsAccepted, setShowTermsModal, toast,
}) {
  return (
    <>
      <div className="app-shell">
        <header className="header">
          <div className="header-titulo no-click">✦</div>
        </header>
        <div className="pantalla">
          <div className="contenido" style={{ maxWidth: 420, margin: "0 auto" }}>
            <button className="btn btn-gris btn-sm" style={{ marginBottom: 16 }} onClick={() => setJoinScreen("welcome")}>
              ← {t(landingLang, "back")}
            </button>

            {joinScreen === "login" ? (
              <>
                <h2 className="seccion-titulo">{t(landingLang, "welcomeBack")}</h2>
                <p className="seccion-subtitulo">{joinFamilyName}</p>
                <div className="card">
                  <div className="campo">
                    <label className="campo-label">{t(landingLang, "email")}</label>
                    <input className="campo-input" type="email" placeholder="you@email.com"
                      value={loginForm.email} onChange={(e) => setLoginForm((f) => ({ ...f, email: e.target.value }))} />
                  </div>
                  <div className="campo">
                    <label className="campo-label">{t(landingLang, "password")}</label>
                    <input className="campo-input" type="password" placeholder="••••••"
                      value={loginForm.password} onChange={(e) => setLoginForm((f) => ({ ...f, password: e.target.value }))} />
                  </div>
                  {authError && <p style={{ color: "#c0392b", fontSize: 13, marginBottom: 12, background: "#fff0f0", border: "1px solid #ffd0d0", borderRadius: 8, padding: "10px 14px" }}>⚠️ {authError}</p>}
                  <button className="btn btn-negro btn-full" onClick={handleLogin}>{t(landingLang, "signIn")}</button>
                  <div style={{ textAlign: "center", marginTop: 10, marginBottom: 4 }}>
                    <span onClick={handleForgotPassword} style={{ fontSize: 12, color: "#d4a853", cursor: "pointer", textDecoration: "underline" }}>
                      {landingLang === "es" ? "¿Olvidaste tu contraseña?" : landingLang === "fi" ? "Unohditko salasanasi?" : "Forgot your password?"}
                    </span>
                  </div>
                  <div className="separador">— or —</div>
                  <button className="btn btn-gris btn-full" onClick={() => setJoinScreen("register")}>{t(landingLang, "createAccount")}</button>
                </div>
              </>
            ) : (
              <>
                <h2 className="seccion-titulo">{t(landingLang, "joinFamily")}</h2>
                <p className="seccion-subtitulo">{joinFamilyName}</p>
                <div className="card">
                  <div className="campo">
                    <label className="campo-label">{t(landingLang, "yourName")}</label>
                    <input className="campo-input" placeholder={t(landingLang, "namePlaceholder")}
                      value={registerForm.name} onChange={(e) => setRegisterForm((f) => ({ ...f, name: e.target.value }))} />
                  </div>

                  {/* ── NICKNAME EN ESTE GRUPO ── */}
                  <div className="campo">
                    <label className="campo-label">
                      {landingLang === "es" ? "¿Cómo quieres aparecer en este grupo?" : landingLang === "fi" ? "Millä nimellä näyt tässä ryhmässä?" : "How do you want to appear in this group?"}
                    </label>
                    <input
                      className="campo-input"
                      placeholder={
                        landingLang === "es" ? "Nickname (opcional — si lo dejas vacío usará tu nombre)"
                        : landingLang === "fi" ? "Lempinimi (valinnainen)"
                        : "Nickname (optional — leave empty to use your real name)"
                      }
                      value={registerForm.groupNickname || ""}
                      onChange={(e) => setRegisterForm((f) => ({ ...f, groupNickname: e.target.value }))}
                    />
                    {registerForm.groupNickname ? (
                      <p style={{ fontSize: 11, color: "#d4a853", marginTop: 4 }}>
                        {landingLang === "es" ? `Los demás te verán como "${registerForm.groupNickname}"` : `Others will see you as "${registerForm.groupNickname}"`}
                      </p>
                    ) : (
                      <p style={{ fontSize: 11, color: "#aaa", marginTop: 4 }}>
                        {landingLang === "es" ? `Te verán como "${registerForm.name || "tu nombre"}"` : `You'll appear as "${registerForm.name || "your name"}"`}
                      </p>
                    )}
                  </div>

                  <div className="campo">
                    <label className="campo-label">{t(landingLang, "email")}</label>
                    <input className="campo-input" type="email" placeholder="you@email.com"
                      value={registerForm.email} onChange={(e) => setRegisterForm((f) => ({ ...f, email: e.target.value }))} />
                  </div>
                  <div className="campo">
                    <label className="campo-label">{t(landingLang, "password")}</label>
                    <input className="campo-input" type="password" placeholder={t(landingLang, "atLeast6")}
                      value={registerForm.password} onChange={(e) => setRegisterForm((f) => ({ ...f, password: e.target.value }))} />
                  </div>
                  <div className="campo">
                    <label className="campo-label">{t(landingLang, "birthday")}</label>
                    <input className="campo-input" placeholder="DD/MM/YYYY" value={registerForm.birthday} maxLength={10}
                      onChange={(e) => {
                        let v = e.target.value.replace(/\D/g, "");
                        if (v.length >= 3 && v.length <= 4) v = v.slice(0, 2) + "/" + v.slice(2);
                        else if (v.length >= 5) v = v.slice(0, 2) + "/" + v.slice(2, 4) + "/" + v.slice(4, 8);
                        setRegisterForm((f) => ({ ...f, birthday: v }));
                      }} />
                  </div>
                  {authError && <p style={{ color: "#c0392b", fontSize: 13, marginBottom: 12, background: "#fff0f0", border: "1px solid #ffd0d0", borderRadius: 8, padding: "10px 14px" }}>⚠️ {authError}</p>}
                  <div style={{ display: "flex", alignItems: "flex-start", gap: 10, margin: "12px 0", cursor: "pointer" }} onClick={() => setTermsAccepted((v) => !v)}>
                    <div style={{ width: 20, height: 20, borderRadius: 5, border: "2px solid " + (termsAccepted ? "#d4a853" : "#e0dbd2"), background: termsAccepted ? "#d4a853" : "transparent", flexShrink: 0, display: "flex", alignItems: "center", justifyContent: "center", marginTop: 1 }}>
                      {termsAccepted && <span style={{ color: "#fff", fontSize: 12, fontWeight: 700 }}>✓</span>}
                    </div>
                    <span style={{ fontSize: 12, color: "#999", lineHeight: 1.5 }}>
                      {landingLang === "es" ? "Acepto los " : landingLang === "fi" ? "Hyväksyn " : "I accept the "}
                      <span style={{ color: "#d4a853", textDecoration: "underline" }} onClick={(e) => { e.stopPropagation(); setShowTermsModal(true); }}>
                        {landingLang === "es" ? "Términos y Condiciones" : landingLang === "fi" ? "Käyttöehdot" : "Terms and Conditions"}
                      </span>
                    </span>
                  </div>
                  <button className="btn btn-dorado btn-full" onClick={handleRegister} disabled={!termsAccepted} style={{ opacity: termsAccepted ? 1 : 0.5 }}>
                    {t(landingLang, "signUp")}
                  </button>
                  <div className="separador">— or —</div>
                  <button className="btn btn-gris btn-full" onClick={() => setJoinScreen("login")}>{t(landingLang, "alreadyHaveAccount")}</button>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {toast && <div className="toast">{toast}</div>}
    </>
  );
}
